import { useMemo, useState } from 'react';
import { Row, Col, Tag } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { useEmployeeMock } from '@/entities/employee/api/hooks';
import { useRiskCards, useRiskMeasures } from '@/entities/risk/api/hooks';
import { CardsTab } from './CardsTab';
import { MatrixTab } from './MatrixTab';
import { MeasuresTab } from './MeasuresTab';
import { computeRisksAnalytics } from './utils';
import s from './Risks.module.scss';

export function Risks() {
  const [params] = useSearchParams();
  const empIdRaw = params.get('employeeId');
  const empIdFromUrl = empIdRaw && !Number.isNaN(Number(empIdRaw)) ? Number(empIdRaw) : 0;
  const { data: employeeFromUrl } = useEmployeeMock(empIdFromUrl);

  const { data: cards } = useRiskCards();
  const { data: measures } = useRiskMeasures();
  const [now] = useState(Date.now);

  const allCards = useMemo(() => cards ?? [], [cards]);
  const allMeasures = useMemo(() => measures ?? [], [measures]);

  const analytics = useMemo(() => computeRisksAnalytics(allCards, allMeasures, now), [allCards, allMeasures, now]);

  return (
    <>
      {(analytics.reviewOverdue > 0 || analytics.overdue > 0) && (
        <div className={s['root__alert-banner']}>
          {analytics.reviewOverdue > 0 && (
            <Tag color="error">Просрочен пересмотр: {analytics.reviewOverdue} карт(а)</Tag>
          )}
          {analytics.overdue > 0 && <Tag color="error">Просроченные мероприятия: {analytics.overdue}</Tag>}
          {analytics.reviewSoon > 0 && <Tag color="warning">Пересмотр в ближайшие 30 дн: {analytics.reviewSoon}</Tag>}
        </div>
      )}

      <Row gutter={[14, 14]} className={s['root__top-row']}>
        <Col xs={24} lg={14}>
          <CardsTab workplaceIdFilter={employeeFromUrl?.workplaceId} />
        </Col>
        <Col xs={24} lg={10}>
          <MatrixTab />
        </Col>
      </Row>

      <Row gutter={[14, 14]} className={s['root__top-row']}>
        <Col span={24}>
          <MeasuresTab />
        </Col>
      </Row>
    </>
  );
}
